/**
 * Created by guntherclaes on 03/03/2017.
 */

require('angular-highlightjs');
require('highlight.js/styles/railscasts.css');
require('ngclipboard');

var vskoCodeExample = angular.module('vskoCodeExample', ['hljs', 'ngclipboard']);
vskoCodeExample.directive('vskoCodeExample', ['$compile', '$location', function($compile, $location) {

  return {
    restrict: "E",
    template: require( './vsko-code-example.html' ),
    replace: true,
    transclude: {
      exampleTitle: '?exampleTitle',
      exampleDescription: '?exampleDescription',
      example: 'example',
    },
    scope: {
      id: '@',
      noCode: '='
    },
    link: function( $scope, element, attrs, ctrl, transclude ) {
      transclude(function (content) { 
          var rawHtml = content[0].innerHTML.replace('=""', '');
          $scope.html = rawHtml;
          element.find('.br-sample-content').append($compile(rawHtml)($scope.$parent));
      }, null, 'example'); 

      $scope.linkToExample = function () {
        $location.hash($scope.id);
      }
    }
  };
}]);

